import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'react-final-form';
import Select from '../Select';

export const renderSelect = ({
  input: { value, onChange, onBlur },
  meta: { touched, error },
  onChange: onFieldChange,
  initialValue,
  setInitialValue,
  ...props
}) => {
  const handleChange = (e) => {
    onChange(e);
    if (setInitialValue) {
      setInitialValue(e);
    }

    if (onFieldChange) {
      onFieldChange(e);
    }
  };

  return (
    <Select
      error={touched && !!error}
      helperText={touched && error}
      value={value || initialValue}
      onChange={handleChange}
      onBlur={onBlur}
      {...props}
    />
  );
};

renderSelect.propTypes = {
  input: PropTypes.shape({
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
  }),
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  onChange: PropTypes.func,
  defaultval: PropTypes.string,
};

renderSelect.defaultProps = {
  input: {
    value: '',
    onChange: () => {},
    onBlur: () => {},
  },
  meta: {
    touched: false,
    error: '',
  },
  onChange: () => {},
  defaultval: 'USA',
};

const FormSelect = ({ name, ...props }) => <Field name={name} component={renderSelect} {...props} />;

FormSelect.propTypes = {
  name: PropTypes.string.isRequired,
};

export default FormSelect;
